import { createContext, useContext } from 'react'

import KnownError from 'src/lib/known-error'

export const READ_ONLY_SUBJECTS_IN_SIMULATION = [
    'my-team',
    'raci',
    'assets',
    'templates',
    'playbooks',
]

/**
 * @typedef {Object} SimulationCtx Context object which contains simulation mode metadata
 * @property {string} simulationId A unique identifier for the current simulation session
 * @property {boolean} isEnabled
 * @property {(enabled:boolean) => void} setEnabled
 */

/**
 * @type {ReturnType<typeof createContext<SimulationCtx>>}
 */
const SimulationCtx = createContext()

export const SimulationCtxProvider = ({
    isEnabled,
    setEnabled,
    simulationId,
    children,
}) => {
    return (
        <SimulationCtx.Provider
            value={{
                simulationId,
                isEnabled,
                setEnabled,
            }}
        >
            {children}
        </SimulationCtx.Provider>
    )
}

export function useSimulationEnabled() {
    const ctx = useContext(SimulationCtx)

    if (!ctx) {
        throw new KnownError('Please wrap with SimulationCtx.Provider')
    }

    return ctx.isEnabled
}

export default SimulationCtx
